<template>
  <div>
    <h1>Registrar destino</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre del destino">
                <a-input ref="name" placeholder="Nombre del destino" v-model="$v.destination.name.$model" />
                <small class="text-danger" v-if="!$v.destination.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredDestination($v.destination.name.$model)">Ya existe un registro con este nombre de destino</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredDestination($v.destination.name.$model) && !$v.$invalid)" v-if="this.clicked === 0">
                  Registrar
                </button>
                <button class="btn btn-gray px-5"  v-else-if="this.clicked === 1">Cargando...</button>
                <button class="btn btn-success px-5"  v-else-if="this.clicked === 2">Se a registrado exitosamente</button>
                <button class="btn btn-danger px-5"  v-else-if="this.clicked === 3">Ha ocurrido un error</button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_DESTINATION = gql`
  mutation createDestination($name: String, $active: Int, $createdBy: String){
    createDestination(destination: {name: $name active: $active createdBy: $createdBy}){
      id
      name
      active
    }
  }
`
const GET_ALL_DESTINATIONS = gql`
  query getAllDestinations{
    getAllDestinations{
      id
      name
      createdBy
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      destination: {
        name: '',
      },
      createdBy: this.$store.state.user.email,
      registeredDestination: {},
      clicked: 0,
    }
  },
  apollo: {
    getAllDestinations: {
      query: GET_ALL_DESTINATIONS,
      result({ data }) {
        data.getAllDestinations.forEach(destination => {
          this.registeredDestination[destination.name] = 1
        })
        console.log('registered destination')
        console.log(this.registeredDestination)
      },
      context: headers(),
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      if (this.clicked === 0) {
        this.clicked = 1
        this.$apollo.mutate({
          mutation: CREATE_DESTINATION,
          variables: {
            name: this.destination.name,
            active: 1,
            createdBy: this.createdBy,
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.clicked = 2
            this.$router.push({ name: 'getDestinations' })
          })
          .catch(error => {
            this.clicked = 3
            console.log(error)
          })
      }
    },
    validateRegisteredDestination(destination) {
      if (this.registeredDestination[destination.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  validations: {
    destination: {
      name: { required },
    },
  },
}
</script>
